var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"paragraph-first-letter-big",class:[ _vm.options.color || ''],domProps:{"innerHTML":_vm._s(_vm.options.letter)}})}
var staticRenderFns = []

export { render, staticRenderFns }